"use strict";

class GraphQL {

  constructor()
  {
    this.url = '/api/2022-04/graphql.json';
    this.storefrontAccessToken = '1471eedbe345c174ddf2a9999a5bca4e';
  }

  // API送信
  async sendAPI(data) {
    return await fetch(this.url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/graphql',
        'X-Shopify-Storefront-Access-Token': this.storefrontAccessToken
      },
      body: data
    })
    .then((response) => {
      return response.json();
    })
    .catch((reason) => {
      console.log('error', reason);
    });
  }


  // customerAccessTokenの作成
  async customerAccessTokenCreate(input) {
    const query = `
      mutation {
        customerAccessTokenCreate(input: {
          email: "${input.email}",
          password: "${input.password}"
      }) {
          customerAccessToken {
            accessToken
          }
          customerUserErrors {
            code
            message
          }
        }
      }
    `;

    const result = await this.sendAPI(query);
    if (result.data.customerAccessTokenCreate.customerUserErrors.length == 0) {
      return result.data.customerAccessTokenCreate.customerAccessToken.accessToken;
    } else {
      // ID、パスワードが間違っているときなど
      throw new Error(result.data.customerAccessTokenCreate.customerUserErrors[0].message);
    }
  }

  // デフォルトの住所を変更
  async customerDefaultAddressUpdate(address_id, customerAccessToken) {
    const query = `
      mutation {
        customerDefaultAddressUpdate(addressId: "gid://shopify/MailingAddress/${address_id}?model_name=CustomerAddress", customerAccessToken: "${customerAccessToken}") {
          customer  {
            id
          }
          customerUserErrors  {
            code
            message
          }
        }
      }
    `;

    return await this.sendAPI(query);
  } 

} 